import { sub, add } from 'date-fns';
import { toInterfaceDayFormat } from 'utils/date';

export const today = new Date();
export const yesterday = sub(today, { days: 1 });
export const lastMonth = sub(today, { months: 1 });
export const lastWeek = sub(today, { weeks: 1 });
export const endOfWeek = add(lastWeek, { weeks: 1 });

export const formatDate = (date: Date) => {
  return toInterfaceDayFormat(date);
};

// TODO: TFR-47 Move hooks utils and effects into proper repository (hooks or utils)
